import { List } from 'antd';
import styled from 'styled-components';

const { Item } = List;

const ItemSelected = styled(Item)`
  position: sticky;
  top: 0;
  margin-bottom: 1rem;
  padding: 1rem;
  background-color: #fff;
  border: 1px solid rgba(0, 0, 0, 0.1);
  border-radius: 1rem;
  z-index: 1;

  animation: slideInUp;
  animation-duration: 1s;
`;

export default { ItemSelected };
